import React, { useState, useEffect } from 'react';
import axios from '../../../utils/fvAxios';
import MenuItem from '@mui/material/MenuItem';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { TextField, Typography, Button, Divider } from '@mui/material';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import * as Yup from 'yup';
import { useTranslation } from "react-i18next";
import "../../../Localization/i18n";
import PrequalificationInformation from './PrequalificationInformation';
import BaseURL from '../../../utils/base-uri.json';

export default function EditAdmin() {
    const { t } = useTranslation();

    const validationSchema = Yup.object().shape({
        legalName: Yup.string()
            .required('Legal name is required !')
            .min(6, 'Legal name must be at least 6 characters')
            .max(20, 'Legal name must not exceed 20 characters'),
        officername: Yup.string()
            .required('Company Principal Officer Name is required !'),   
        taxID: Yup.string()
            .required('TaxID is required !')
            .matches(/^([07][1-7]|1[0-6]|2[0-7]|[35][0-9]|[468][0-8]|9[0-589])-?\d{7}$/, 'formet like 00-0000000'),
        country: Yup.string()
            .required('Country is required !'),
        state: Yup.string()
            .required('State is required !'),
        city: Yup.string()
            .required('City is required !'),
        zip: Yup.string()
            .required('Zip is required !'),
        addressline1: Yup.string()
            .required('Address line 1 is required !'),
        telephoneNumber: Yup.string()
            .required('Telephone number is required !')
            .matches(/^\(\d{3}\) \d{3}-\d{4}$/, 'format like (000) 000-0000'),

    });

    const {
        register,
        handleSubmit,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema)
    });

    const [error, setError] = useState(null);
    const [states, setStates] = useState([]);
    const [countries, setCountries] = useState([]);

    useEffect(() => {
        axios.get(BaseURL.baseUrl + 'Common/GetCountries')
            .then((res) => {
                if (res.data.responseCode === 100) {
                    setCountries(res.data.data)
                }
                else {
                    setError(res.data.responseMessage);
                }
            }).catch(err => {
                console.log(err)
            })
    }, []);

    const getState = (e) => {
        axios.get(BaseURL.baseUrl + "Common/GetCountryStatesByClientId?country=" + e)
            .then((res) => {
                if (res.data.responseCode === 100) {
                    setStates(res.data.data.response)
                }
                else {
                    setError(res.data.responseMessage);
                }
            }).catch(err => {
                console.log(err)
            })

    }

    const onSubmit = (data) => {
        console.log(data);
    };
    return (
        <>
            <div className='form'>
                <label className='personal-info-heading'><b>{t('Mycompany.businessinformation')}</b></label>

                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">Select Sub Client(s)</span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                            }}
                            select
                            required
                            size='small'
                            placeholder="Select Sub Client"
                            name="subclient"
                            id="subclient"
                            value={10}
                            className="form-control text-feild-custom mx-2"
                            {...register('subclient')}
                        >
                            <MenuItem value={10}>All</MenuItem>
                        </TextField>
                        <Typography className='text-danger mx-2 mt-1' component={'span'}>
                            {errors.subclient?.message}
                        </Typography>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>

                <Divider className='mt-3' />

                <div className='row'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">{t('Mycompany.registration')}</span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1 ">
                        <RadioGroup
                            className="mx-2"
                            required
                            type="radio"
                            id="selecttype"
                            name="selecttype"
                        >
                            <FormControlLabel value="U.S" {...register("selecttype")} control={<Radio />} label="U.S" />
                            <FormControlLabel value="International"{...register("selecttype")} control={<Radio />} label="International" />
                        </RadioGroup>
                        <Typography className='text-danger mx-2 mt-1' component={'span'} >
                            {errors.selecttype?.message}
                        </Typography>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>

                <Divider />

                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-4">
                        <span className="input-label-right">{t('Mycompany.legalname')} <small style={{ color: "red" }}>*</small></span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 }
                            }}
                            required
                            id="legalName"
                            name="legalName"
                            placeholder={t('Mycompany.legalname')}
                            size='small'
                            className="form-control text-feild-custom mx-2"
                            {...register('legalName')}
                        />
                        <Typography className='text-danger mx-2 mt-1' component={'span'}>
                            {errors.legalName?.message}
                        </Typography>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>

                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">{t('Mycompany.country')} <small style={{ color: "red" }}>*</small></span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                            }}
                            select
                            required
                            size='small'
                            placeholder={t('Mycompany.country')}
                            name="country"
                            id="country"
                            className="form-control text-feild-custom mx-2"
                            {...register('country')}
                            onChange={(e) => getState(e.target.value)}
                        >
                            {countries.map((item, index) => (

                                <MenuItem key={index} value={item.value}>
                                    {item.value}
                                </MenuItem>
                            ))}
                        </TextField>
                        <Typography className='text-danger mx-2 mt-1' component={'span'}>
                            {errors.country?.message}
                        </Typography>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>

                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">{t('Mycompany.state')} <small style={{ color: "red" }}>*</small></span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                            }}
                            select
                            type="text"
                            id='state'
                            required
                            name="state"
                            placeholder={t('Mycompany.state')}
                            size='small'
                            className="form-control text-feild-custom mx-2"
                            {...register('state')}
                        >
                            {states.map((item, index) => (

                                <MenuItem key={index} value={item.value}>
                                    {item.value}
                                </MenuItem>
                            ))}
                        </TextField>
                        <Typography className='text-danger mx-2 mt-1' component={'span'}>
                            {errors.state?.message}
                        </Typography>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>

                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">{t('Mycompany.city')} <small style={{ color: "red" }}>*</small></span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                            }}
                            required
                            id="city"
                            name="city"
                            placeholder={t('Mycompany.city')}
                            size='small'
                            className="form-control text-feild-custom mx-2"
                            {...register('city')}
                        />
                        <Typography className='text-danger mx-2 mt-1' component={'span'}>
                            {errors.city?.message}
                        </Typography>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>

                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3 ">
                        <span className="input-label-right">{t('Mycompany.zip')} <small style={{ color: "red" }}>*</small></span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                            }}
                            required
                            id="zip"
                            name="zip"
                            placeholder={t('Mycompany.zip')}
                            size='small'
                            className="form-control text-feild-custom mx-2"
                            {...register('zip')}
                        />
                        <Typography className='text-danger mx-2 mt-1' component={'span'}>
                            {errors.zip?.message}
                        </Typography>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>

                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right"> {t('Mycompany.addressline1')} <small style={{ color: "red" }}>*</small> </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1 ">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                            }}
                            required
                            id="addressline1"
                            name="addressline1"
                            placeholder={t('Mycompany.addressline1')}
                            size='small'
                            className="form-control text-feild-custom mx-2"
                            {...register('addressline1')}
                        />
                        <Typography className='text-danger mx-2 mt-1' component={'span'}>
                            {errors.addressline1?.message}
                        </Typography>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>

                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right"> {t('Mycompany.addressline2')} </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1 ">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                            }}
                            required
                            id="addressline2"
                            name="addressline2"
                            placeholder={t('Mycompany.addressline2')}
                            size='small'
                            className="form-control text-feild-custom mx-2"
                            {...register('addressline2')}
                        />
                        <Typography className='text-danger mx-2 mt-1' component={'span'}>
                            {errors.addressline2?.message}
                        </Typography>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>

                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">{t('Mycompany.addressline3')} </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1 ">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                            }}
                            required
                            id="addressline3"
                            name="addressline3"
                            placeholder={t('Mycompany.addressline3')}
                            size='small'
                            className="form-control text-feild-custom mx-2"
                            {...register('addressline3')}
                        />
                        <Typography className='text-danger mx-2 mt-1' component={'span'}>
                            {errors.addressline3?.message}
                        </Typography>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>

                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">{t('Mycompany.telephonenumber')}<small style={{ color: "red" }}>*</small></span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                            }}
                            required
                            id="telephoneNumber"
                            name="telephoneNumber"
                            placeholder={t('Mycompany.telephonenumber')}
                            size='small'
                            className="form-control text-feild-custom mx-2"
                            {...register('telephoneNumber')}
                        />
                        <Typography className='text-danger mx-2 mt-1' component={'span'}>
                            {errors.telephoneNumber?.message}
                        </Typography>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>

                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">{t('Mycompany.phonenumberextension')}</span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                            }}
                            required
                            id="phoneNumber"
                            name="phoneNumber"
                            placeholder={t('Mycompany.phonenumberextension')}
                            size='small'
                            className="form-control text-feild-custom mx-2"
                            {...register('phoneNumber')}
                        />
                        <Typography className='text-danger mx-2 mt-1' component={'span'}>
                            {errors.phoneNumber?.message}
                        </Typography>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>

                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">{t('Mycompany.faxnumber')} </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                            }}
                            required
                            id="faxNumber"
                            name="faxNumber"
                            placeholder={t('Mycompany.faxnumber')}
                            size='small'
                            className="form-control text-feild-custom mx-2"
                            {...register('faxNumber')}
                        />
                        <Typography className='text-danger mx-2 mt-1' component={'span'}>
                            {errors.faxNumber?.message}
                        </Typography>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>

                <Divider className='mt-3' />

                <div className='row mt-2'>
                    <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
                        <span className="input-label-right">{t('Mycompany.websiteurl')} </span>
                    </div>
                    <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
                        <TextField
                            sx={{
                                '& legend': { display: 'none' },
                                '& fieldset': { top: 0 },
                            }}
                            required
                            id="website"
                            name="website"
                            placeholder={t('Mycompany.websiteurl')}
                            size='small'
                            className="form-control text-feild-custom mx-2"
                            {...register('website')}
                        />
                        <Typography className='text-danger mx-2 mt-1' component={'span'}>
                            {errors.website?.message}
                        </Typography>
                    </div>
                    <div className="col-sm-2 col-md-2 col-xl-2 block">
                    </div>
                </div>

                <Divider className='mt-3' />

                <div className='row mt-3 mb-3'>
                    <div className='text-right'>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit(onSubmit)}
                        >
                            {t('Mycompany.save')}
                        </Button>
                    </div>
                </div>
                {error && <div className="text-center" style={{ color: "red" }}>{error}</div>}
            </div>

            <div className="mt-3">
                 <PrequalificationInformation /> 
            </div>
            
        </>
    )
}
